import { render, staticRenderFns } from "./gold.vue?vue&type=template&id=7641c754&"
import script from "./gold.vue?vue&type=script&lang=js&"
export * from "./gold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports